import { CreateMunicipalPropertyInput } from "@/graphql/generated/graphql";

import { MunicipalPropertyCreateFormValues } from "./municipal-property-create-form-values";

interface ToCreateMunicipalPropertyInputOptions {
  workspaceId: string;
  values: MunicipalPropertyCreateFormValues;
}

import { toMunicipalPropertyMasterDataInput } from "./to-municipal-property-master-data-input";

export function toCreateMunicipalPropertyInput({
  workspaceId,
  values,
}: ToCreateMunicipalPropertyInputOptions): CreateMunicipalPropertyInput {
  return {
    workspaceId,
    effectiveYear: values.effectiveYear,
    ...toMunicipalPropertyMasterDataInput(values),
    municipalityIdList: values.municipalityIdList,
  };
}
